define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/topic",
	"dijit/MenuItem",
	"csi",
	"csi/_base/underscore",
	"csi/comm",
	"csi/def",
	"csi/def/Action",
	"csi/def/Request",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/sessionConstants",
	"csi/view/ToolbarDropDown",
	"csi/widget/Menu",
	"csi/xml"
], function(array, declare, lang, topic, MenuItem, csi, _, comm, def, Action, Request, ViewRef, locale, sessionConstants, ToolbarDropDown, Menu, xml) {

	return declare(ToolbarDropDown, {
		enablePlugin: function(/*Context?*/ctx) {
			// summary: context for freeze should always be PO
			if (ctx && ctx.isReadOnly() && !csi.objectNumberOfElements(ctx.getParent().PDFs)) {
				this._setDisabled(this, true);
			} else {
				this.inherited(arguments);
			}
		},

		postMixInProperties: function() {
			// summary: set appearance based on action
			this._mixinActionProperties();
			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: set up menu items to generate a new PDF and view existing ones
			var tb = this.actionToolbar;
			var ctx = tb.view.getContext();
			var node = tb.view.getViewNode();

			this.inherited(arguments);
			this.dropDown = new Menu({});

			// add menu item to generate PDF - wait 30 seconds rather than typical 5 seconds
			if (!ctx.isReadOnly()) {
				var action = lang.mixin(new Action(), {
					classController: "SiteAdmin.GeneratePDF",
					target: node.$Type,
					m_accessAction: "SiteAdmin.onAccessActionGeneratePDF",
					m_onAction: function(ac) {ac.waitDelay = 60000;},
					m_id: "GeneratePDF",
					m_class: "far fa-fw fa-file-pdf",
					m_request: lang.mixin(new Request(), {
						m_module: "CollectionBook",
						m_operation: "SalesCollectionGeneratePDF"
					}),
					m_right: xml.RIGHT_WRITE,
					m_typeControl: def.ACTION_ICON,
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "GeneratePDFForm"
					})
				});
				action.resolve();
				tb.addPlugin(ctx, action, null, null, this.dropDown);
				tb.addPlugin(ctx, "|", null, null, this.dropDown);
			}

			// create menu items for each locale
			this._addPdfs(node);
			this.dropDown.startup();

			// listen for notifications when PDF request is complete to update toolbar
			this.own(topic.subscribe("/csi/pdf/complete", lang.hitch(this, this._onPdfComplete)));
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: do not show if portal user and no PDFs generated
			var node = ctx.view.getViewNode();
			return !sessionConstants.isPortalUser || csi.objectNumberOfElements(node.PDFs);
		},

		_addPdfs: function(/*Node*/node) {
			// summary: add new menu item for locale PDF
			var locales = csi.sort(Object.keys(node.PDFs), function(loc) {return locale.resource(loc);});

			array.forEach(locales, function(loc) {
				this.dropDown.addChild(new MenuItem({
					label: _.escape(locale.resource(loc)),
					pluginName: this.pluginName,
					onClick: lang.hitch(this, this._onClickLocale, loc)
				}));
			}, this);
		},

		_onClickLocale: function(/*String*/loc, /*Event*/evt) {
			// summary: open PDF in another window
			var node = this.actionToolbar.view.getViewNode();

			csi.browserWindow(comm.getFileHref(node.PDFs[loc], false, node.$Name + " - " + locale.resource(loc)));
		},

		_onPdfComplete: function(/*Node?*/pdfRequest, /*Boolean*/bSuccess) {
			// summary: wait for successful PDF request owned by this node
			var view = this.actionToolbar.view;
			var url = view.getViewURL();

			if (view.isValidView() && pdfRequest && (pdfRequest.__Parent__ == url)) {
				if (bSuccess) {
					// make sure get latest version of node
					var node = view.cacheView.addNode(url);

					// remove existing menu items for each PDF
					var menuItems = this.dropDown.getChildren();

					for (var i = menuItems.length - 1; i >= 2; --i) {
						this.dropDown.removeChild(menuItems[i]);
					}

					// add new menu items - this ensures that always have updated list
					this._addPdfs(node);
				}

				this.actionToolbar.enablePlugins();
			}
		}
	});
});